export const URLs = {
  activity: "activities",
  authMe: "auth/me",
  category: "categories",
  comment: "comments",
  contact: "contacts",
  login: "login",
  member: "members",
  news: "news",
  organization: "organization",
  project: "projects",
  role: "roles",
  register: "register",
  slides: "slides",
  socialMediaItem: "socialMediaItems",
  testimonial: "testimonials",
  users: "users",
}
